export default "__VITE_ASSET__WjQeLQOu__"